<BaseDialog 
  bind:show={show} 
  {title}
  {hint}>

  <div>
    {#if !upload.status}
      <Panel mt="nm" align="left">
        <Text nm color="body">{@html messages.intro}</Text>
      </Panel>
      <Panel mt="md" align="center">
        <input 
          class="hidden"
          type="FILE" 
          id="import-record-def-file-selector" 
          on:change={(ev) => { fileSelected(ev); }}
          />
        <Button nm bold color="primary" py="0.75" rounded="xs" border="0" hover pointer
          on:click={selectFile}>
          <b>{messages.select.toUpperCase()}</b>
        </Button>
      </Panel>
    {/if}

    {#if upload.status === SELECTED}
      <Panel mt="nm" align="left">
        <Text md color="body">
          {messages.selected} 
          <br><b>{ upload.name } ({ upload.size })</b>
        </Text>
      </Panel>
      <Panel mt="md" align="center">
        <Button nm bold color="primary" py="0.75" rounded="xs"  border="0" hover pointer
          on:click={() => uploadFile()}>
          <b>{messages.upload.toUpperCase()}</b>
        </Button>
      </Panel>
    {/if}

    {#if upload.status === UPLOADING}
      <Panel mt="nm" align="left">
        <Text md color="body">
          {messages.working} 
          <br><b>{upload.name}</b>
        </Text>
      </Panel>
      <Panel mt="sm" align="left" line="double">
        <Text bold lg>{upload.percent.toFixed(0)}%</Text>
      </Panel>
    {/if}

    {#if upload.status === DONE}
      <MessageCard icon="valid" status="success" mt="nm">
        <Text md>
          {messages.done}:<br><b>{upload.name}</b>
        </Text>
        <Panel mt="sm">
          {@html messages.continue}
        </Panel>
     </MessageCard>
    {/if}

    {#if upload.status === FAILED}              
      <MessageCard icon="error" status="error" mt="nm">
        <Text md>
          {messages.failed}:<br><b>{upload.name}</b>
        </Text>
        <Panel mt="sm">
          <Text color="body" nm>{@html failureMsg[upload.error]}</Text>
        </Panel>
      </MessageCard>
    {/if}
  </div>
 
</BaseDialog>


<script>
  import { onMount, tick } from 'svelte';
  import { Overlay, Panel, Box, Text, Icon, Button } from 'svelte-stylo';
  import MessageCard from '../cards/MessageCard.svelte';
  import BaseDialog from './BaseDialog.svelte';

  export let
    show = false,
    url = null,
    title = '',
    hint = null,//"elige un archivo que ya antes ....",
    messages = { 
      intro: '', 
      select: '',
      selected: '', 
      upload: '',
      working: '', 
      done:'', 
      continue: '',
      failed: ''
    },
    onDone = null;

  let response = null;

  const
    SELECTED = 1,
    UPLOADING = 2,
    DONE = 3,
    FAILED = -1,
    FILE_SELECTOR_BUTTON = 'import-record-def-file-selector';

  const failureMsg = {
    "500": `Ha ocurrido una falla en nuestro servicio, por favor reintenta nuevamente en unos minutos.`,
    "!500": `Probablemente sea algún error en el archivo subido.
            <br>Por favor corrige el archivo y vuelve a intentarlo.`
  }

  let upload = {
    status: null,
    file: null,
    name: '',
    size: 0,
    percent: 0,
    type: '',
    error: null,
    message: ''
  };

  function selectFile() {
    // Trigger the file selector 
    let fileSelector = document.getElementById(FILE_SELECTOR_BUTTON);
    fileSelector.click();
  }

  function fileSelected(ev) {
    const files = ev.target.files;
    upload.file = files[0]; // just keep one
    upload.name = files[0].name;
    upload.size = files[0].size;
    upload.percent = 0;
    upload.status = SELECTED;
    upload.message = ""
  }

  async function uploadFile() {
    // alert("Upload file")
    try {
      response = await (API.upload(url, upload.file, {
        'progress': function (e) {
          upload.status = UPLOADING;
          upload.percent = (e.loaded / e.total) * 100;
        }
      }));

      // reset the file input control and files array
      upload.file = null;
      upload.status = DONE;

      doneIt()
    } 
    catch (e) {
      // Exception 'e' contains { error, message }
      console.log(e);
      upload.status = FAILED;
      upload.error = e.error === 500 ? '500' : '!500';
      upload.message = e.message;
    }
  }

  function doneIt() {
    onDone && onDone(response);
    setTimeout(async () => {
      await tick();
      closeIt();
    }, 3500)
  }

  function closeIt() {
    // we can/must do cleanup here !
    show = false;
    upload.status = null;
  }

</script>
